import SignupForm from "../../Components/auth/SignupForm";
import Header from "../../Components/header/Header";
import "./SignUp.css"; 

export default function SignUp() {
  return (
    <div className="signup-page">
      <div className="signup-top-border"></div>
      <Header />
      <div className="signup-main-container">
        <div className="signup-left-section">
          <img
           src="/mountain.webp"
            alt="Mountain"
            className="signup-bg-image"
          />
        </div>
        <div className="signup-right-section">
          <SignupForm />
        </div>
      </div>
    </div>
  );
}